export default function convertLinksToAnchors(metin) {
  // URL'leri bulmak için düzenli ifade
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;

  // URL'leri HTML linklerine dönüştür
  return metin.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="_blank">' + url + "</a>";
  });
}



// WEBPACK FOOTER //
// ./src/helpers/convertLinksToAnchors.js